import { render, staticRenderFns } from "./requestInfo.vue?vue&type=template&id=496aaef8"
import script from "./requestInfo.vue?vue&type=script&lang=js"
export * from "./requestInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports